import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';
import authSupplier from '@/helpers/authSupplier';

Vue.use(Router);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

const isAuthSupplier = (to, from, next) => {
	if (!authSupplier.loggedIn()) {
		next({
			name: 'login-supplier',
			query: { redirect: to.fullPath },
		});
	} else {
		if (to.path == "/supplier") {
			next({
				name: 'dashboard-supplier',
			});
		} else {
			next();
		}
	}
};

const isUnauthSupplier = (to, from, next) => {
	if (authSupplier.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard-supplier' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkExactActiveClass: 'exact-active',
	linkActiveClass: 'active',
	routes: [{
		path: '/auth',
		component: () =>
		import ('@/views/MLwarehouse/layout/Auth.vue'),
		children: [{
			path: 'login',
			name: 'login',
			beforeEnter: isUnauth,
			component: () =>
			import ('@/views/auth/Login.vue'),
		}, {
			path: 'login-supplier',
			name: 'login-supplier',
			beforeEnter: isUnauthSupplier,
			component: () =>
			import ('@/views/auth/LoginSuplier.vue'),
		}],
	}, {
		path: '/',
		component: () =>
		import ('@/views/MLwarehouse/layout/Main.vue'),
		beforeEnter: isAuth,
		children: [{
			path: '/',
			name: 'dashboard',
			component: () => import ('@/views/MLwarehouse/dashboard/Dashboard.vue'),
		}, {
			path: '/dashboard-center',
			name: 'dashboard-center',
			component: () => import ('@/views/MLwarehouse/dashboardAll/Dashboard.vue'),
		}, {
			path: '/warehouse',
			name: 'warehouse',
			component: () => import ('@/views/MLwarehouse/warehouse/Warehouse.vue'),
		}, {
			path: '/user',
			name: 'user',
			component: () => import ('@/views/MLwarehouse/user/DataUser.vue'),
		}, {
			path: '/user-warehouse',
			name: 'user-warehouse',
			component: () => import ('@/views/MLwarehouse/user/DataUserWarehouse.vue'),
		}, {
			path: '/user-supplier',
			name: 'user-supplier',
			component: () => import ('@/views/MLwarehouse/user/DataUserSupplier.vue'),
		}, {
			path: '/list-supplier',
			name: 'list-supplier',
			component: () => import ('@/views/MLwarehouse/supplier/Supplier.vue'),
		}, {
			path: '/product-supplier',
			name: 'product-supplier',
			component: () => import ('@/views/MLwarehouse/supplierProduct/SupplierProduct.vue'),
		}, {
			path: '/add-product-supplier',
			name: 'add-product-supplier',
			component: () => import ('@/views/MLwarehouse/supplierProduct/AddSupplierProduct.vue'),
		}, {
			path: '/product',
			name: 'product',
			component: () => import ('@/views/MLwarehouse/product/Product.vue'),
		}, {
			path: '/product-bundling',
			name: 'product-bundling',
			component: () => import ('@/views/MLwarehouse/product/ProductBundling.vue'),
		}, {
			path: '/product-convert',
			name: 'product-convert',
			component: () => import ('@/views/MLwarehouse/product/ProductConvert.vue'),
		}, {
			path: '/product-convert-warehouse',
			name: 'product-convert-warehouse',
			component: () => import ('@/views/MLwarehouse/product/ProductConvert.vue'),
		}, {
			path: '/add-product-convert',
			name: 'add-product-convert',
			component: () => import ('@/views/MLwarehouse/product/AddProductConvert.vue'),
		}, {
			path: '/serial-product',
			name: 'serial-product',
			component: () => import ('@/views/MLwarehouse/product/ProductSerial.vue'),
		}, {
			path: '/serial-distribution',
			name: 'serial-distribution',
			component: () => import ('@/views/MLwarehouse/product/SalesSerial.vue'),
		}, {
			path: '/free-tools',
			name: 'free-tools',
			component: () => import ('@/views/MLwarehouse/product/FreeTools.vue'),
		}, {
			path: '/customer',
			name: 'customer',
			component: () => import ('@/views/MLwarehouse/customer/Customer.vue'),
		}, {
			path: '/product-category',
			name: 'product-category',
			component: () => import ('@/views/MLwarehouse/categoryProduct/CategoryProduct.vue'),
		}, {
			path: '/list-purchase-order',
			name: 'list-purchase-order',
			component: () =>
			import ('@/views/MLwarehouse/po/Po.vue'),
		}, {
			path: '/list-purchase-order-warehouse',
			name: 'list-purchase-order-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/po/Po.vue'),
		}, {
			path: '/approval-purchase-order/:code?',
			name: 'approval-purchase-order',
			component: () =>
			import ('@/views/MLwarehouse/po/Approve-po.vue'),
		}, {
			path: '/add-purchase-order',
			name: 'add-purchase-order',
			component: () =>
			import ('@/views/MLwarehouse/po/Add-po.vue'),
		}, {
			path: '/list-purchase-delivery-order',
			name: 'list-purchase-delivery-order',
			component: () =>
			import ('@/views/MLwarehouse/pdo/Pdo.vue'),
		}, {
			path: '/list-purchase-delivery-order-warehouse',
			name: 'list-purchase-delivery-order-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/pdo/Pdo.vue'),
		}, {
			path: '/receipt-purchase-delivery-order/:code?',
			name: 'receipt-purchase-delivery-order',
			component: () =>
			import ('@/views/MLwarehouse/pdo/PdoReceipt.vue'),
		}, {
			path: '/list-sales-order',
			name: 'list-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/So.vue'),
		}, {
			path: '/sales-order-warehouse',
			name: 'sales-order-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/so/SoAllWarehouse.vue'),
		}, {
			path: '/payment-sales-order/:code?',
			name: 'payment-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/SoPayment.vue'),
		}, {
			path: '/approval-sales-order/:code?',
			name: 'approval-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/SoApprove.vue'),
		}, {
			path: '/list-approval-sales-order',
			name: 'list-approval-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/SoApproveList.vue'),
		}, {
			path: '/add-sales-order',
			name: 'add-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/AddSO.vue'),
		}, {
			path: '/annually-sales-order',
			name: 'annually-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/AnnuallySO.vue'),
		}, {
			path: '/list-sales-delivery-order',
			name: 'list-sales-delivery-order',
			component: () =>
			import ('@/views/MLwarehouse/sdo/Sdo.vue'),
		}, {
			path: '/list-sales-delivery-order-warehouse',
			name: 'list-sales-delivery-order-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/sdo/Sdo.vue'),
		}, {
			path: '/add-sales-delivery-order',
			name: 'add-sales-delivery-order',
			component: () =>
			import ('@/views/MLwarehouse/sdo/Add-sdo.vue'),
		}, {
			path: '/stock-product',
			name: 'stock-product',
			component: () =>
			import ('@/views/MLwarehouse/stock/StockProduct.vue'),
		}, {
			path: '/stock-product-log',
			name: 'stock-product-log',
			component: () =>
			import ('@/views/MLwarehouse/stock/StockProductLog.vue'),
		}, {
			path: '/stock-adjustment',
			name: 'stock-adjustment',
			component: () =>
			import ('@/views/MLwarehouse/stockAdjustment/StockAdjustment.vue'),
		}, {
			path: '/add-stock-adjustment',
			name: 'add-stock-adjustment',
			component: () =>
			import ('@/views/MLwarehouse/stockAdjustment/AddStockAdjustment.vue'),
		},  {
			path: '/stock-adjustment-mb',
			name: 'stock-adjustment-mb',
			component: () =>
			import ('@/views/MLwarehouse/stockAdjustment/StockAdjustmentMb.vue'),
		}, {
			path: '/add-stock-adjustment-mb',
			name: 'add-stock-adjustment-mb',
			component: () =>
			import ('@/views/MLwarehouse/stockAdjustment/AddStockAdjustmentMb.vue'),
		},
		{
			path: '/list-stock-opname',
			name: 'list-stock-opname',
			component: () =>
			import ('@/views/MLwarehouse/stockOpname/StockOpname.vue'),
		}, {
			path: '/list-stock-opname-warehouse',
			name: 'list-stock-opname-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/stockOpname/StockOpname.vue'),
		}, {
			path: '/add-stock-opname',
			name: 'add-stock-opname',
			component: () =>
			import ('@/views/MLwarehouse/stockOpname/AddStockOpname.vue'),
		}, {
			path: '/approval-stock-opname/:code?',
			name: 'approval-stock-opname',
			component: () =>
			import ('@/views/MLwarehouse/stockOpname/ApprovalStockOpname.vue'),
		}, {
			path: '/stock-warehouse',
			name: 'stock-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/stock/StockWarehouse.vue'),
		}, {
			path: '/stock-warehouse-log',
			name: 'stock-warehouse-log',
			component: () =>
			import ('@/views/MLwarehouse/stock/StockWarehouseLog.vue'),
		}, {
			path: '/profile',
			name: 'profile',
			component: () =>
			import ('@/views/MLwarehouse/profile/Profile.vue'),
		}, {
			path: '/list-retur',
			name: 'list-retur',
			component: () =>
			import ('@/views/MLwarehouse/retur/Retur.vue'),
		}, {
			path: '/add-retur',
			name: 'add-retur',
			component: () =>
			import ('@/views/MLwarehouse/retur/AddRetur.vue'),
		}, {
			path: '/approve-retur',
			name: 'approve-retur',
			component: () =>
			import ('@/views/MLwarehouse/retur/ApproveRetur.vue'),
		}, {
			path: '/list-transfer-stock',
			name: 'list-transfer-stock',
			component: () =>
			import ('@/views/MLwarehouse/to/To.vue'),
		}, {
			path: '/list-transfer-stock-warehouse',
			name: 'list-transfer-stock-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/to/ToWarehouse.vue'),
		}, {
			path: '/approval-transfer-stock/:code?',
			name: 'approval-transfer-stock',
      meta : {title: 'Approval Transfer Stok'},
			component: () =>
			import ('@/views/MLwarehouse/to/Approve-to.vue'),
		}, {
			path: '/approval-transfer-stock-admin/:code?',
			name: 'approval-transfer-stock-admin',
      meta : {title: 'Approval Transfer Stok Admin'},
			component: () =>
			import ('@/views/MLwarehouse/to/Approve-to.vue'),
		}, {
			path: '/add-transfer-stock',
			name: 'add-transfer-stock',
			component: () =>
			import ('@/views/MLwarehouse/to/Add-to.vue'),
		}, {
			path: '/retur-transfer-stock',
			name: 'retur-transfer-stock',
			component: () =>
			import ('@/views/MLwarehouse/to/Add-to-retur.vue'),
		}, {
			path: '/list-transfer-stock-delivery',
			name: 'list-transfer-stock-delivery',
			component: () =>
			import ('@/views/MLwarehouse/tdo/Tdo.vue'),
		}, {
			path: '/add-transfer-stock-delivery/:code?',
			name: 'add-transfer-stock-delivery',
			component: () =>
			import ('@/views/MLwarehouse/tdo/TdoAdd.vue'),
		}, {
			path: '/receipt-transfer-delivery-order/:code?',
			name: 'receipt-transfer-delivery-order',
			component: () =>
			import ('@/views/MLwarehouse/tdo/TdoReceipt.vue'),
		}, {
			path: '/list-sales-retail',
			name: 'list-sales-retail',
			component: () =>
			import ('@/views/MLwarehouse/sr/Sr.vue'),
		}, {
			path: '/list-sales-retail-warehouse',
			name: 'list-sales-retail-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/sr/Sr.vue'),
		}, {
			path: '/add-sales-retail',
			name: 'add-sales-retail',
			component: () =>
			import ('@/views/MLwarehouse/sr/addSR.vue'),
		}, {
			path: '/list-sales-retail-employee',
			name: 'list-sales-retail-employee',
			component: () =>
			import ('@/views/MLwarehouse/sre/SRE.vue'),
		}, {
			path: '/list-sales-retail-employee-warehouse',
			name: 'list-sales-retail-employee-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/sre/SRE.vue'),
		}, {
			path: '/add-sales-retail-employee',
			name: 'add-sales-retail-employee',
			component: () =>
			import ('@/views/MLwarehouse/sre/addSRE.vue'),
		}, {
			path: '/approval-sales-retail-employee/:code?',
			name: 'approval-sales-retail-employee',
      meta : {title: 'Approval Sales Retail'},
			component: () =>
			import ('@/views/MLwarehouse/sre/approvalSRE.vue'),
		}, {
			path: 'schedules',
			name: 'schedules',
			component: () =>
			import ('@/views/MLwarehouse/schedules/Schedules.vue'),
		}, {
			path: 'schedules-all',
			name: 'schedules-all',
			component: () =>
			import ('@/views/MLwarehouse/schedules/SchedulesAll.vue'),
		}, {
			path: 'list-retur-delivery',
			name: 'list-retur-delivery',
			component: () =>
			import ('@/views/MLwarehouse/retur/ReturDelivery.vue'),
		}, {
			path: 'receive-retur-delivery/:code?',
			name: 'receive-retur-delivery',
			component: () =>
			import ('@/views/MLwarehouse/retur/ReceiveReturDelivery.vue'),
		}, {
			path: 'add-pra-mb',
			name: 'add-pra-mb',
			component: () =>
			import ('@/views/MLwarehouse/customer/AddCustomer.vue'),
		}, {
			path: 'promo-77',
			name: 'promo-77',
			component: () =>
			import ('@/views/MLwarehouse/customer/Promo77.vue'),
		}, {
			path: 'promo-sept2022',
			name: 'promo-sept2022',
			component: () =>
			import ('@/views/MLwarehouse/customer/PromoSept2022.vue'),
		}, {
			path: 'trx-non-order',
			name: 'trx-non-order',
			component: () =>
			import ('@/views/MLwarehouse/trxNonOrder/NonOrder.vue'),
		}, {
			path: 'add-trx-non-order',
			name: 'add-trx-non-order',
			component: () =>
			import ('@/views/MLwarehouse/trxNonOrder/AddNonOrder.vue'),
		}, {
			path: 'approval-trx-non-order',
			name: 'approval-trx-non-order',
			component: () =>
			import ('@/views/MLwarehouse/trxNonOrder/ApprovalNonOrder.vue'),
		}, {
			path: 'trx-non-order-all',
			name: 'trx-non-order-all',
			component: () =>
			import ('@/views/MLwarehouse/trxNonOrder/NonOrder.vue'),
		}, {
			path: 'response-api',
			name: 'response-api',
			component: () =>
			import ('@/views/MLwarehouse/responseApi/ResponseApi.vue'),
		}, {
			path: 'response-api-ecommerce',
			name: 'response-api-ecommerce',
			component: () =>
			import ('@/views/MLwarehouse/responseApi/ResponseApiEcommerce.vue'),
		}, {
			path: 'email-log',
			name: 'email-log',
			component: () =>
			import ('@/views/MLwarehouse/emailLog/EmailLog.vue'),
		}, {
			path: 'approve-serial-convert/:code?',
			name: 'approve-serial-convert',
			component: () =>
			import ('@/views/MLwarehouse/serialConvert/ApproveSerialConvert.vue'),
		}, {
			path: 'serial-convert',
			name: 'serial-convert',
			component: () =>
			import ('@/views/MLwarehouse/serialConvert/SerialConvert.vue'),
		}, {
			path: 'serial-convert-warehouse',
			name: 'serial-convert-warehouse',
			component: () =>
			import ('@/views/MLwarehouse/serialConvert/SerialConvert.vue'),
		},
		{
			path: 'web-referral-theme',
			name: 'web-referral-theme',
			component: () =>
			import ('@/views/MLwarehouse/webReferral/Theme.vue'),
		},
		{
			path: 'product-recall',
			name: 'product-recall',
			component: () =>
			import ('@/views/MLwarehouse/productRecall/Approval.vue'),
		},
		{
			path: 'setting-product-purchase-order-stockist',
			name: 'setting-product-purchase-order-stockist',
			component: () =>
			import ('@/views/MLwarehouse/purchaseOrderStockist/settingProduct.vue'),
		},
		{
			path: 'setting-bv-purchase-order-stockist',
			name: 'setting-bv-purchase-order-stockist',
			component: () =>
			import ('@/views/MLwarehouse/purchaseOrderStockist/settingBV.vue'),
		},
		{
			path: 'setting-progressive-price-purchase-order-stockist',
			name: 'setting-progressive-price-purchase-order-stockist',
			component: () =>
			import ('@/views/MLwarehouse/purchaseOrderStockist/settingProgressivePrice.vue'),
		},
		{
			path: '/list-so-approval-refund',
			name: 'list-so-approval-refund',
			component: () =>
			import ('@/views/MLwarehouse/so/SoApprovalRefund.vue'),
		},
		{
			path: '/approval-refund-sales-order/:code?',
			name: 'approval-refund-sales-order',
			component: () =>
			import ('@/views/MLwarehouse/so/ApproveRefund.vue'),
		}
	]
	}, {
		path: '/ecommerce',
		component: () =>
		import ('@/views/MLwarehouse/layout/Main.vue'),
		beforeEnter: isAuth,
		children: [{
			path: 'mobile-version',
			name: 'ecommerce-mobile-version',
			component: () => import ('@/views/MLecommerce/mobileVersion/MobileVersion.vue'),
		}, {
			path: 'member',
			name: 'ecommerce-member',
			component: () => import ('@/views/MLecommerce/member/Member.vue'),
		}, {
			path: 'new-member',
			name: 'ecommerce-new-member',
			component: () => import ('@/views/MLecommerce/member/NewMember.vue'),
		}, {
			path: 'transaction',
			name: 'ecommerce-transaction',
			component: () => import ('@/views/MLecommerce/transaction/Transaction.vue'),
		}, {
			path: 'transfer-confirmation',
			name: 'ecommerce-transfer-confirmation',
			component: () => import ('@/views/MLecommerce/transaction/TransferConfirmation.vue'),
		}, {
			path: 'transfer-confirmation-cancel',
			name: 'ecommerce-transfer-confirmation-cancel',
			component: () => import ('@/views/MLecommerce/transaction/TransferConfirmation.vue'),
		}, {
			path: 'transaction-cash',
			name: 'ecommerce-transaction-cash',
			component: () => import ('@/views/MLecommerce/transaction/TransactionCash.vue'),
		}, {
			path: 'transaction-va',
			name: 'ecommerce-transaction-va',
			component: () => import ('@/views/MLecommerce/transaction/TransactionVA.vue'),
		}, {
			path: 'product',
			name: 'ecommerce-product',
			component: () => import ('@/views/MLecommerce/product/Product.vue'),
		}, {
			path: 'stockist',
			name: 'ecommerce-stockist',
			component: () => import ('@/views/MLecommerce/stockist/Stockist.vue'),
		}, {
			path: 'stockist-stock',
			name: 'ecommerce-stockist-stock',
			component: () => import ('@/views/MLecommerce/stockist/StockistStock.vue'),
		}, {
			path: 'stockist-stock-log',
			name: 'ecommerce-stockist-stock-log',
			component: () => import ('@/views/MLecommerce/stockist/StockistStockLog.vue'),
		}, {
			path: 'bank',
			name: 'ecommerce-bank',
			component: () => import ('@/views/MLecommerce/bank/Bank.vue'),
		}, {
			path: 'bank-account',
			name: 'ecommerce-bank-account',
			component: () => import ('@/views/MLecommerce/bank/BankAccount.vue'),
		}, {
			path: 'courier',
			name: 'ecommerce-courier',
			component: () => import ('@/views/MLecommerce/courier/Courier.vue'),
		}, {
			path: 'ewallet',
			name: 'ecommerce-ewallet',
			component: () => import ('@/views/MLecommerce/ewallet/Ewallet.vue'),
		}, {
			path: 'ewallet-log',
			name: 'ecommerce-ewallet-log',
			component: () => import ('@/views/MLecommerce/ewallet/EwalletLog.vue'),
		}, {
			path: 'ewallet-process',
			name: 'ecommerce-ewallet-process',
			component: () => import ('@/views/MLecommerce/ewallet/EwalletProcess.vue'),
		}, {
			path: 'ewallet-withdraw',
			name: 'ecommerce-ewallet-withdraw',
			component: () => import ('@/views/MLecommerce/ewallet/EwalletWithdraw.vue'),
		},
		]
	}, {
		path: '/supplier',
		component: () => import ('@/views/MLsupplier/layout/Main.vue'),
		beforeEnter: isAuthSupplier,
		children: [{
			path: '',
			beforeEnter: (to, from, next) => {
				next({ name: 'dashboard-supplier' });
			}
		}, {
			path: 'dashboard-supplier',
			name: 'dashboard-supplier',
			component: () => import ('@/views/MLsupplier/dashboard/Dashboard.vue'),
		}, {
			path: 'supplier-user',
			name: 'supplier-user',
			component: () => import ('@/views/MLsupplier/user/User.vue'),
		}, {
			path: 'supplier-product',
			name: 'supplier-product',
			component: () => import ('@/views/MLsupplier/product/Product.vue'),
		}, {
			path: 'purchase-order',
			name: 'purchase-order',
			component: () => import ('@/views/MLsupplier/po/PO.vue'),
		}, {
			path: 'approve-purchase-order',
			name: 'approve-purchase-order',
			component: () => import ('@/views/MLsupplier/po/ApprovePO.vue'),
		}, {
			path: 'list-penjualan',
			name: 'list-penjualan',
			component: () => import ('@/views/MLsupplier/po/PO.vue'),
		}, {
			path: 'approval-penjualan/:code?',
			name: 'approval-penjualan',
			component: () => import ('@/views/MLsupplier/po/ApprovePO.vue'),
		}, {
			path: 'pengiriman',
			name: 'pengiriman',
			component: () => import ('@/views/MLsupplier/pdo/PDO.vue'),
		}, {
			path: 'jadwal-pengiriman',
			name: 'jadwal-pengiriman',
			component: () => import ('@/views/MLsupplier/schedules/Schedules.vue'),
		}, {
			path: 'calendar-pengiriman',
			name: 'calendar-pengiriman',
			component: () => import ('@/views/MLsupplier/schedules/CalendarSchedules.vue'),
		}, {
			path: 'tambah-pengiriman/:code?',
			name: 'tambah-pengiriman',
			component: () => import ('@/views/MLsupplier/pdo/AddPDO.vue'),
		}, {
			path: 'po-outstanding',
			name: 'po-outstanding',
			component: () => import ('@/views/MLsupplier/outstanding/Outstanding.vue'),
		}, {
			path: 'list-retur',
			name: 'list-retur-supplier',
			component: () =>
			import ('@/views/MLsupplier/retur/Retur.vue'),
		}, {
			path: 'approve-retur/:code?',
			name: 'approve-retur-supplier',
			component: () =>
			import ('@/views/MLsupplier/retur/ApproveRetur.vue'),
		}, {
			path: 'list-retur-delivery',
			name: 'list-retur-delivery-supplier',
			component: () =>
			import ('@/views/MLsupplier/retur/ReturDelivery.vue'),
		}, {
			path: 'delivery-retur/:code?',
			name: 'delivery-retur-supplier',
			component: () =>
			import ('@/views/MLsupplier/retur/AddReturDelivery.vue'),
		}, {
			path: 'profile',
			name: 'profileSupplier',
			component: () =>
			import ('@/views/MLsupplier/profile/Profile.vue'),
		}, ]
	}, {
		path: '/logistic',
		name: 'path-for-logistic',
		component: () => import ('@/views/MLlogistic/layout/Main.vue'),
		beforeEnter: isAuth,
		children: [{
			path: 'driver',
			name: 'driver',
			component: () => import ('@/views/MLlogistic/driver/DataDriver.vue'),
		}, {
			path: 'armada',
			name: 'armada',
			component: () => import ('@/views/MLlogistic/armada/DataArmada.vue'),
		}, {
			path: 'expedition-schedule',
			name: 'expedition-schedule',
			component: () => import ('@/views/MLlogistic/expedition/schedule/AddExpeditionSchedule.vue'),
		}, {
			path: 'expedition-tracking',
			name: 'expedition-tracking',
			component: () => import ('@/views/MLlogistic/expedition/tracking/ExpeditionTracking.vue'),
		}, {
			path: 'expedition-report',
			name: 'expedition-report',
			component: () => import ('@/views/MLlogistic/expedition/report/ExpeditionReport.vue'),
		}, {
			path: 'expedition-report/:code?',
			name: 'expedition-report-detail',
			component: () => import ('@/views/MLlogistic/expedition/report/DetailReport.vue'),
		} ]
	}, {
		path: "*",
		component: () => import ('@/views/404.vue'),
	}, {
		path: "/supplier/*",
		component: () => import ('@/views/404Supplier.vue'),
	}],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});

router.beforeEach((to, from, next) => {
	const user_menu = auth.getMenu();
	if (user_menu.type == 'superuser') {
		next()
	} else if (user_menu.type == 'administrator' && to.path.indexOf("/supplier") == -1 && to.path.indexOf("/auth") == -1) {
		const menu_slug = user_menu.menu.map((el) => el.menu_slug)
		if (!menu_slug.includes(to.name)) {
			next({name: 'dashboard'})
		}
		next()
	} else {
		next()
	}
	next()
})

export default router
